export const manifest = {
  screens: {
    scr_ys8j4e: { name: "Overview", route: "/", position: {"x":160,"y":5780} },
    scr_5s5c6y: { name: "Report Library", route: "/reports", position: {"x":160,"y":1820} },
    scr_sndwh6: { name: "Report Viewer", route: "/reports/master-appointments", position: {"x":1560,"y":1820} },
    scr_cu6ga4: { name: "Report Builder", route: "/builder", state: {"wizardOpen":false}, position: {"x":1560,"y":3800} },
    scr_rabv44: { name: "Builder — Guided Start", route: "/builder", state: {"wizardOpen":true}, position: {"x":2960,"y":3800} },
    scr_k1hidi: { name: "My Templates", route: "/templates", position: {"x":160,"y":3800} },
    scr_cjh95w: { name: "Settings", route: "/settings", position: {"x":0,"y":0}, isDefaultRow: true },
  },
  sections: {
    sec_xxb8gl: { name: "Reports", x: 0, y: 1600, width: 2920, height: 1180 },
    sec_bvpvvn: { name: "Report Creation", x: 0, y: 3580, width: 4320, height: 1180 },
    sec_hlrh1m: { name: "Home", x: 0, y: 5560, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_xxb8gl", children: [
      { kind: "screen", id: "scr_5s5c6y" },
      { kind: "screen", id: "scr_sndwh6" },
    ] },
    { kind: "section", id: "sec_bvpvvn", children: [
      { kind: "screen", id: "scr_k1hidi" },
      { kind: "screen", id: "scr_cu6ga4" },
      { kind: "screen", id: "scr_rabv44" },
    ] },
    { kind: "section", id: "sec_hlrh1m", children: [
      { kind: "screen", id: "scr_ys8j4e" },
    ] },
    { kind: "screen", id: "scr_cjh95w" },
  ],
}
